/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountAttrsUpdateAdmin
 */
export interface AccountAttrsUpdateAdmin {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AccountAttrsUpdateAdmin
     */
    attrs?: { [key: string]: string; };
}

export function AccountAttrsUpdateAdminFromJSON(json: any): AccountAttrsUpdateAdmin {
    return {
        'attrs': !exists(json, 'attrs') ? undefined : json['attrs'],
    };
}

export function AccountAttrsUpdateAdminToJSON(value?: AccountAttrsUpdateAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'attrs': value.attrs,
    };
}


